import React, { useEffect, useState, useRef } from 'react';

import { Progress } from '@/components/ui/progressbar';

import { useAuthenticated } from './hooks/useAuthenticated';
import { useCart, useRemoveItem } from './hooks/useCart';
interface FreeShippingNoticeProps {
    name?: string;
}
export const FreeShippingNotice = ({ name }: FreeShippingNoticeProps) => {
    const freeShippingThresholdNumber = Number(window?.tscConfig?.FreeShippingThreshold);
    useEffect(() => {}, []);
    const isAuthenticated = useAuthenticated();
    const { data: cart } = useCart(isAuthenticated);
    const [delayedPercentage, setDelayedPercentage] = useState(0);
    const isRogersCCFreeShipApplied = cart?.OrderSummary?.IsRogersCCFreeShipApplied;
    const isAutoFreeShipApplied = cart?.OrderSummary?.IsAutoFreeShipApplied;
    const autoFreeShipAwayFromThresholdAmount = Number(cart?.OrderSummary?.AutoFreeShipAwayFromThresholdAmount);
    const difference =
        autoFreeShipAwayFromThresholdAmount == 0
            ? 0
            : freeShippingThresholdNumber - autoFreeShipAwayFromThresholdAmount;
    const percentage = Math.min(Math.round((difference / freeShippingThresholdNumber) * 100), 100);
    const [isOpen, setIsOpen] = useState(false);
    const prevIsOpen = useRef(isOpen);

    const showAutoFreeShip =
        (isAutoFreeShipApplied || autoFreeShipAwayFromThresholdAmount > 0) && freeShippingThresholdNumber > 0;

    // New condition for free shipping when threshold is 0 and auto free ship is applied
    const showAutoFreeShipNoThreshold = freeShippingThresholdNumber === 0 && isAutoFreeShipApplied;
    // Set isOpen to true after the component initially loads
    useEffect(() => {
        setIsOpen(true);
    }, []);

    useEffect(() => {
        let timer;
        if (prevIsOpen.current === false && isOpen === true) {
            //delayed open
            timer = setTimeout(() => {
                setDelayedPercentage(percentage);
            }, 600);
        } else {
            setDelayedPercentage(percentage);
        }
        prevIsOpen.current = isOpen;
        // Cleanup function to clear the timer
        return () => clearTimeout(timer);
    }, [isOpen, percentage]);

    const NoFreeShipping = () => null;

    return (
        <>
            {showAutoFreeShip ? (
                <>
                    <div className="mb-5 border-2 border-solid border-tscteal bg-white px-5 py-2 text-xsm md:mb-2.5">
                        <div className="flex flex-col justify-between md:flex-row md:items-center md:gap-1 md3:flex-col md3:gap-0 lg2:flex-row lg2:gap-1">
                            <div className="mb-1 mt-2.5 text-center text-xs leading-5 md:order-3 md:m-0 md:w-7/12 md:text-right md3:mb-1 md3:mt-2.5 md3:w-full md3:text-center min-[1090px]:text-xs lg2:m-0 lg2:w-7/12 lg2:whitespace-nowrap lg2:text-right">
                                {isAutoFreeShipApplied ? (
                                    <>
                                        You&apos;ve earned <b>FREE standard shipping!</b>
                                    </>
                                ) : (
                                    <>
                                        <span>
                                            You&apos;re <b>{cart?.OrderSummary?.AutoFreeShipAwayFromThreshold}</b>{' '}
                                            from{' '}
                                        </span>
                                        <span>
                                            <b>
                                                FREE standard shipping on{' '}
                                                <a
                                                    href="/pages/customer-service/shipping-handling"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="whitespace-nowrap !underline"
                                                >
                                                    eligible items
                                                </a>
                                            </b>
                                        </span>
                                    </>
                                )}
                            </div>
                            <div className="md:order-2"></div>
                            <div className="mb-0 grid h-9 grid-cols-[auto_1fr_auto] gap-2 md:order-1 md:w-5/12 md3:order-3 md3:w-full lg2:order-1 lg2:w-5/12">
                                <div className="flex items-center justify-center">$0</div>
                                <div className="flex items-center justify-center">
                                    <Progress value={delayedPercentage} />
                                </div>
                                <div className="flex items-center justify-center">${freeShippingThresholdNumber}</div>
                            </div>
                        </div>
                    </div>
                </>
            ) : showAutoFreeShipNoThreshold ? (
                <>
                    <div className="mb-5 border-2 border-solid border-tscteal bg-white px-5 py-2 text-xsm md:mb-2.5">
                        <div className="min-h-9 content-center text-center text-xs leading-4 lg2:text-left">
                            You&apos;ve earned <b>FREE standard shipping!</b>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    {isRogersCCFreeShipApplied ? (
                        <>
                            <div className="mb-5 border-2 border-solid border-tscteal bg-white px-5 py-2 text-xsm md:mb-2.5">
                                <div className="min-h-9 content-center text-center text-xs leading-4 lg2:text-left">
                                    You&apos;ve earned <b>FREE standard shipping</b> with{' '}
                                    <b className="whitespace-nowrap">Rogers Bank Mastercard!</b>
                                </div>
                            </div>
                        </>
                    ) : (
                        <NoFreeShipping />
                    )}
                </>
            )}
        </>
    );
};
